// DESIGN TOKENS FINSERA :)

// Design tokens are named design values that define a design system's visual style.
// They are essentially small, reusable design decisions that are stored as data and
// can be used across multiple platforms and tools. Think of them as the fundamental
// building blocks of a UI, like colors, fonts, spacing, and animations

// FINSERA_LEGACY
export const PRIMARY_NAV_WIDTH = '40px';
export const LEFT_DRAWER_WIDTH = '270px';
export const LEFT_DRAWER_COLLAPSED_WIDTH = '34px';
export const APP_BAR_HEIGHT = '50px';
export const REPORT_BAR_HEIGHT = '50px';
export const SAVE_BAR_HEIGHT = 64;
export const TAB_HEIGHT = '41px';
export const POPPER_WIDTH = '400px';
export const REPORT_TAB_HEIGHT = 42;
export const EDITOR_FONT_SIZE = 14;
export const ASSISTANT_WIDTH = 500;
export const ASISTANT_Z_INDEX = 1010;
export const SIDEBAR_COLLAPSE_PADDING = '24px';
export const SIDEBAR_TAB_SIZE = '50px';
export const INPUT_SAFE_CONTAINER = '900px';
export const DRAG_DROP_HEIGHT = 32;
export const LARGE_DRAG_DROP_HEIGHT = 44;
export const SECURE_FORM_SIZE = 600;
export const MIN_TABLE_HEIGHT = 200;
export const PORTFOLIO_SECTION_HEIGHT = '50vh';
export const PORTFOLIO_SMALL_WIDGET_HEIGHT = '330px';
export const PORTFOLIO_LARGE_WIDGET_HEIGHT = '450px';

export const INPUT_SIZE = {
  xs: '26px',
  sm: '32px',
  md: '40px',
};

//  TIPOGRAPHY
export const FONT_FAMILY =
  // eslint-disable-next-line max-len
  'Inter, -apple-system, BlinkMacSystemFont, Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';

export const FONT_SIZE = {
  xxs: '0.625rem', // 10px
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px
  base: '1rem', // 16px
  md: '1.125rem', // 18px
  lg: '1.25rem', // 20px
  xl: '1.5rem', // 24px
};

// COLORS
export const SECTION_BG = 'rgba(27, 31, 55, 0.025)';
export const SECTION_BG_DARK = 'rgba(27, 31, 55, 0.0333)';
export const SECTION_BG_DARKER = 'rgba(27, 31, 55, 0.05)';
export const TRANSPARENT_BG = 'rgba(255, 255, 255, 0.666)';
export const CHART_BLUE = '#6189C4';
export const COLOR_SECONDARY = '#939CAE';
export const COLOR_SUCCESS = '#3B9E4B';
export const COLOR_ERROR = '#D13743';
export const TABLE_HIGHLIGHT_BG = 'rgba(25, 118, 210, 0.05)';

// Tables

export const TABLE_ROW_HEIGHT = {
  sm: 30,
  md: 45,
  lg: 60,
  xl: 75,
};

// Layout Sizes

export const PORTFOLIO_CONTAINER = 'xl';

// Z-indexes

export const Z_INDEX = {
  xs: '800',
  sm: '1000',
  md: '1200',
  xl: '1400',
  lg: '1600',
};
